"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.initialState = void 0;
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var authActions = __importStar(require("./actions"));
var userActions = __importStar(require("@app/features/users/state/actions"));
exports.initialState = {
    isAuthenticated: false,
    termsOfServiceAccepted: false
};
var authReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Auth actions
        case typesafe_actions_1.getType(authActions.loginReject): {
            return __assign(__assign({}, state), { isAuthenticating: false, isAuthenticated: false, isLogoutInitiated: action.payload.initiateLogout, loginError: action.payload.message });
        }
        case typesafe_actions_1.getType(authActions.loginRequest):
            return __assign(__assign({}, state), { isAuthenticating: true, isLogoutInitiated: false, loginError: '', userInfo: undefined });
        case typesafe_actions_1.getType(authActions.loginSuccess):
            return __assign(__assign({}, state), { isAuthenticating: false, isAuthenticated: true, userInfo: action.payload.user, authCheckComplete: true });
        case typesafe_actions_1.getType(authActions.logoutRequest):
            return __assign(__assign({}, state), { isLogoutInitiated: true });
        case typesafe_actions_1.getType(authActions.logoutSuccess):
            return __assign(__assign({}, state), { isAuthenticated: false, isLogoutInitiated: true, userInfo: undefined });
        case typesafe_actions_1.getType(authActions.refreshActivityAction):
            return __assign(__assign({}, state), { blastActivityTimestamp: action.payload, isLogoutInitiated: (action.payload === undefined) ? true : false });
        case (typesafe_actions_1.getType(authActions.requestPasswordResetLoad)):
            return __assign(__assign({}, state), { isRequestingPasswordReset: false, requestPasswordResetSuccess: false, requestPasswordResetError: '' });
        case (typesafe_actions_1.getType(authActions.requestPasswordResetReject)):
            return __assign(__assign({}, state), { isRequestingPasswordReset: false, requestPasswordResetSuccess: false, requestPasswordResetError: action.payload });
        case (typesafe_actions_1.getType(authActions.requestPasswordResetRequest)):
            return __assign(__assign({}, state), { isRequestingPasswordReset: true });
        case (typesafe_actions_1.getType(authActions.requestPasswordResetSuccess)):
            return __assign(__assign({}, state), { isRequestingPasswordReset: false, requestPasswordResetSuccess: true, requestPasswordResetError: '' });
        case (typesafe_actions_1.getType(authActions.resetPasswordReject)):
            return __assign(__assign({}, state), { isResettingPassword: false, passwordResetError: action.payload });
        case (typesafe_actions_1.getType(authActions.resetPasswordRequest)):
            return __assign(__assign({}, state), { isResettingPassword: true, passwordResetError: '' });
        case (typesafe_actions_1.getType(authActions.resetPasswordSuccess)):
            return __assign(__assign({}, state), { isResettingPassword: false, passwordResetError: '' });
        case typesafe_actions_1.getType(authActions.updateAuthCheckComplete):
            return __assign(__assign({}, state), { authCheckComplete: true });
        case (typesafe_actions_1.getType(authActions.updateTermsOfServiceAcceptance)):
            return __assign(__assign({}, state), { termsOfServiceAccepted: action.payload });
        // User actions
        case (typesafe_actions_1.getType(userActions.storeAsperaConnectIdSuccess)): {
            var stateUserInfo = state.userInfo;
            if (stateUserInfo && stateUserInfo.appId !== action.payload.connectId) {
                stateUserInfo.appId = action.payload.connectId;
            }
            if (stateUserInfo && stateUserInfo.asperaVersion !== action.payload.connectVersion) {
                stateUserInfo.asperaVersion = action.payload.connectVersion;
            }
            return __assign(__assign({}, state), { userInfo: stateUserInfo });
        }
        default:
            return state;
    }
};
exports.authReducer = authReducer;
